import { Controller, useFormContext } from "react-hook-form";

import type { DatePickerProps } from "@luna-restaurant/ui";
import { DatePicker } from "@luna-restaurant/ui";

export type FormDatePickerProps = {
  name: string;
} & Omit<DatePickerProps, "value" | "onChange" | "onBlur">;

export function FormDatePicker({ name, ...inputProps }: FormDatePickerProps) {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, onBlur, value }, fieldState }) => (
        <DatePicker
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          error={fieldState.error?.message ?? false}
          {...inputProps}
        />
      )}
    />
  );
}
